export const GET_COUNTRIES = 'Countries/GET_COUNTRIES'
export const GET_COUNTRIES_SUCCESS = 'Countries/GET_COUNTRIES_SUCCESS'
export const GET_COUNTRIES_ERROR = 'Countries/GET_COUNTRIES_ERROR'

export const SET_COUNTRY = 'Countries/SET_COUNTRY'

export const getCountries = () => ({
  type: GET_COUNTRIES,
})

export const setCountry = (id: number) => ({
  type: SET_COUNTRY,
  id,
})
